<template>
	<div>
		<bread-crumbs
			:title="$t('OnDemand.AssignedVisits')"
			:subTitle="$t('general.SubtitleAssignedVisits')"
			:sizeTitle="30"
			:lineHeightTitle="37"
			:sizeSubTitle="15"
			:lineHeightSubTitle="18"
		></bread-crumbs>
		<div class="vx-row mb-2">
			<div class="vx-col w-full flex items-center">
				<feather-icon
					class="g-breadcrumb--title"
					icon="ChevronLeftIcon"
					svgClasses="h-8 w-8"
					@click.prevent="$router.push({name: 'apps-on-demand'})"
				/>
				<vs-breadcrumb
					class="g-breadcrumb--title"
					separator=""
					:items="[{title: $t('general.Return')}]"
					@click.prevent="$router.push({name: 'apps-on-demand'})"
				></vs-breadcrumb>
			</div>
		</div>
		<div class="vx-row">
			<div class="vx-col w-full">
				<vx-card>
					<div slot="no-body">
						<vs-table
							:data="dispatchedOrders"
							class="table-dark-inverted p-4"
							max-items="15"
							pagination
							search
						>
							<template slot="thead">
								<vs-th>N</vs-th>
								<vs-th>{{ $t("Status") | mayus }}</vs-th>
								<vs-th>{{ $t("Activity.Activity") | mayus }}</vs-th>
								<vs-th>{{ $t("VisitPoint") | mayus }}</vs-th>
								<vs-th>{{ $t("Resource.Resource") | mayus }}</vs-th>
								<vs-th>{{ $t("Routing.DistanceRoute") | mayus }}</vs-th>
								<vs-th>{{ $t("OnDemand.ScheduledHour") | mayus }}</vs-th>
								<vs-th>{{ $t("OnDemand.ExecutedHour") | mayus }}</vs-th>
								<vs-th>{{ $t("Map") | mayus }}</vs-th>
							</template>

							<template slot-scope="{data}">
								<vs-tr :key="indextr" v-for="(tr, indextr) in data">
									<vs-td :data="data[indextr].id">
										<span>{{ data[indextr].id }}</span>
									</vs-td>
									<vs-td :data="data[indextr].status">
										<vs-chip
											:color="colors[statusColor(data[indextr].event_status_id)]"
											class="font-semibold"
											>{{ statusText(data[indextr].event_status_id) | capitalize }}
										</vs-chip>
									</vs-td>
									<vs-td :data="data[indextr].id">
										<span>{{ data[indextr].activity_name | capitalize }}</span>
									</vs-td>

									<vs-td :data="data[indextr].id">
										<span class="truncate"
											>{{ data[indextr].visit_point_name | capitalize }} -
											{{ fullAddress(data[indextr]) | capitalize }}</span
										>
									</vs-td>

									<vs-td :data="data[indextr].id">
										<ul class="users-liked user-list">
											<li>
												<div class="flex flex-row">
													<vx-tooltip
														:text="$t('OnDemand.ViewResourceCalendar')"
														position="bottom"
													>
														<vs-avatar
															@click="goToResourceCalendar(data[indextr].resource_id)"
															:src="contactImage(data[indextr].resource_id)"
															size="30px"
															class="border-2 border-white border-solid -m-1"
														></vs-avatar>
													</vx-tooltip>
													<span class="ml-2 truncate font-semibold">{{
														data[indextr].username
													}}</span>
												</div>
											</li>
										</ul>
									</vs-td>

									<vs-td :data="data[indextr].id">
										<on-demand-distance
											:event="data[indextr]"
											:color="colors[statusColor(data[indextr].event_status_id)]"
										/>
									</vs-td>
									<vs-td :data="data[indextr].id">
										<span> {{ data[indextr].init_hour }} - {{ data[indextr].end_hour }}</span>
									</vs-td>
									<vs-td :data="data[indextr].id">
										<span v-if="data[indextr].event_init_hour">{{
											data[indextr].event_init_hour
										}}</span>
										<feather-icon
											v-if="!data[indextr].event_init_hour"
											icon="ClockIcon"
											svgClasses="h-4 w-4"
											class="ml-1"
										/>
										-
										<span v-if="data[indextr].event_end_hour">{{
											data[indextr].event_end_hour
										}}</span>
										<feather-icon
											v-if="!data[indextr].event_end_hour"
											icon="ClockIcon"
											svgClasses="h-4 w-4"
											class="ml-1"
										/>
									</vs-td>
									<vs-td :data="data[indextr].id">
										<vx-tooltip
											:text="
												!disabledMapBtn(data[indextr])
													? $t('OnDemand.DisabledMapBtnTitle')
													: $t('OnDemand.TrackingOnTheMap')
											"
											position="bottom"
										>
											<vs-button
												color="primary"
												type="border"
												icon-pack="feather"
												icon="icon-map"
												:disabled="!disabledMapBtn(data[indextr])"
												@click="handleBtnMapClick(data[indextr])"
											></vs-button>
										</vx-tooltip>
									</vs-td>
								</vs-tr>
							</template>
						</vs-table>
					</div>
				</vx-card>
			</div>

			<vs-popup :fullscreen="false" :active.sync="activeMapPopup" :title="$t('Maps')">
				<map-view-on-demand
					v-if="activeMapPopup"
					name="map-iot"
					latitude="4.686699"
					longitude="-74.0837187"
					zoom="13"
					theme="uber"
					mapType="here"
					calledFrom="onDemand"
					width="50vw"
					height="70vh"
					:markerData="[resource]"
					:onDemandEvent="itemSelected"
				></map-view-on-demand>
			</vs-popup>
		</div>
	</div>
</template>

<script>
// Custom components
import OnDemandDistance from "./OnDemandDistance.vue";
// Store Modules
import moduleSchedule from "@/store/schedule/moduleSchedule.js";
import moduleResource from "@/store/resource/moduleResource.js";
// Helpers
import DateUtils from "@/helpers/DateUtils.js";
import firebase from "firebase/app";
import moment from "moment";
// Models
import User from "@/models/User.js";
import Notification from "@/models/Notification.js";
import MapViewOnDemand from "./MapView";
export default {
	components: {
		MapViewOnDemand,
		OnDemandDistance,
	},
	data() {
		return {
			selectedDay: new Date(),
			dispatchedOrders: [],
			colors: {
				agendado: "#3aaaff",
				reprogramado: "#ffe15a",
				cancelado: "#ff0000",
				finalizado: "#28c76f",
				en_proceso: "#113a60",
				delayed: "#ff7070",
				"on-the-way": "#ffbe81",
				selected: "#a0a0a0",
				ondemand: "#886ce4",
			},
			activeMapPopup: false,
			resource: null,
			itemSelected: null,
			database: firebase.database(),
			notificationsNumber: 100,
			userSession: new User(),
		};
	},
	computed: {
		contactImage() {
			return function (id) {
				const contact = this.$store.getters["chat/contactImg"](id);
				return contact ? contact.img : null;
			};
		},
		fullAddress() {
			return function ({address, city}) {
				return address + " " + city;
			};
		},
		dataEventsDay() {
			return this.$store.state.moduleSchedule.events ? this.$store.state.moduleSchedule.events : [];
		},
		statusColor() {
			return (label) => {
				switch (label) {
					case 1:
						return "not-assigned";
					case 2:
						return "agendado";
					case 3:
						return "reprogramado";
					case 4:
						return "delayed";
					case 5:
						return "on-the-way";
					case 6:
						return "en_proceso";
					case 7:
						return "finalizado";
					case 8:
						return "cancelado";
					default:
						break;
				}
			};
		},
		statusText() {
			return (label) => {
				let text = "";
				switch (label) {
					case 1:
						text = this.$t("Schedule.NotAssigned");
						break;
					case 2:
						text = this.$t("Schedule.Scheduled");
						break;
					case 3:
						text = this.$t("Schedule.ReProgramming");
						break;
					case 4:
						text = this.$t("Schedule.Delayed");
						break;
					case 5:
						text = this.$t("Schedule.OnTheWay");
						break;
					case 6:
						text = this.$t("Schedule.InProgress");
						break;
					case 7:
						text = this.$t("Schedule.Finished");
						break;
					case 8:
						text = this.$t("Schedule.Canceled");
						break;
					default:
						break;
				}
				return text.toLowerCase();
			};
		},
		disabledMapBtn() {
			return ({event_status_id}) => event_status_id === 4 || event_status_id === 5;
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		getEvents() {
			const payload = {
				init_date: DateUtils.toDefaultDateTime(this.selectedDay, "YYYY-MM-DD"),
				end_date: DateUtils.toDefaultDateTime(this.selectedDay, "YYYY-MM-DD"),
				event_status_id: [2, 3, 4, 5, 6, 7],
				fields: ["on_demand", "event_init_hour", "event_end_hour"],
			};
			this.openLoading();
			this.$store
				.dispatch("moduleSchedule/fetchEventsOnDemand", payload)
				.then((res) => {
					this.dispatchedOrders = res.filter((event) => event.on_demand);
					this.listenEventNotifications();
					this.closeLoading();
				})
				.catch((err) => {
					this.closeLoading();
					console.error(err);
				});
		},
		/**
		 * TODO: Obtener la informacion de un evento
		 * @param {Number } eventId id del evento a buscar
		 */
		async getEventById(eventId) {
			const payload = {
				init_date: DateUtils.toDefaultDateTime(this.selectedDay, "YYYY-MM-DD"),
				end_date: DateUtils.toDefaultDateTime(this.selectedDay, "YYYY-MM-DD"),
				id: [eventId],
				fields: ["on_demand", "event_init_hour", "event_end_hour"],
			};
			try {
				const response = await this.$store.dispatch("moduleSchedule/fetchEventById", payload);
				if (response.length > 0) return response[0];
			} catch (error) {
				return null;
			}
		},
		handleBtnMapClick(item) {
			this.getResourceInfo(item.resource_id);
			this.itemSelected = item;
		},
		getResourceInfo(userId = 0) {
			const payload = {
				ids: [userId],
			};
			this.openLoading();
			this.$store
				.dispatch("moduleResource/fetchResourceFilterById", payload)
				.then((res) => {
					if (res.data.records.length > 0) {
						this.resource = res.data.records[0];
						// Actualizamos la imagen del recurso, la obtenemos de la info del chat
						const contactInfo = this.$store.getters["chat/contactImg"](this.resource.id);
						this.resource.img_url = contactInfo ? contactInfo.img : null;
						this.activeMapPopup = true;
					}
					this.closeLoading();
				})
				.catch((err) => {
					this.closeLoading();
					console.error(err);
				});
		},

		handleUpdateEvent({key, event}) {
			const eventIndex = this.dispatchedOrders.findIndex(({id}) => id === +key);
			if (eventIndex >= 0) {
				this.updateEventStateFromList(event, eventIndex);
				if (event === "EVENT_IN_PROGRESS" || event === "EVENT_FINALIZED") {
					this.updateEventFromList(key, eventIndex);
				}
			}
		},
		/**
		 * TODO: Agregar un nuevo elemento a la lista
		 * @param {Object} event
		 */
		addEventToList(event) {
			const someEvent = this.dispatchedOrders.some(({id}) => id === event.id);
			if (!someEvent) this.dispatchedOrders.unshift(event);
		},

		async updateEventFromList(eventId, index) {
			const event = await this.getEventById(+eventId);
			if (event) {
				this.dispatchedOrders[index].event_status_id = event.event_status_id;
				this.dispatchedOrders[index].event_init_hour = event.event_init_hour;
				this.dispatchedOrders[index].event_end_hour = event.event_end_hour;
			}
		},

		updateEventStateFromList(notificationEvent, index) {
			this.dispatchedOrders[index].event_status_id = this.notificationEventStatus(notificationEvent);
		},
		/**
		 * TODO: Escuchar las notificaciones entrantes del dia actual
		 */
		async listenEventNotifications() {
			// Obtenemos la preferencias guardadas en el indexedDB del navegador
			const preferences = await this.$store.dispatch("modulePreferences/getPreferences");
			if (preferences) {
				this.notificationsNumber = preferences.notifications_number;
			}

			/*
      Obtener la fecha actual y le restamos el numero de dias para ver notificaciones
      la completamos con el tiempo en 00 00 00 para filtrar en firebase
      */
			const currentDate = DateUtils.toDefaultDateTime(new Date(), "YYYY-MM-DD");
			const startAt = currentDate.split("-").join("") + "000000";

			const user = await this.userSession.getUser();
			const starCountRef = this.database
				.ref(`notification/${user.company_id}/web/`)
				.orderByChild("date")
				.startAt(+startAt)
				.limitToLast(+this.notificationsNumber);

			// Escuchar los cambios cuando entra una nueva notificacion
			starCountRef.on("child_added", async (data) => {
				const notification = new Notification({
					...data.val(),
					key: data.key,
				});

				// Validamos que la notificacion sea de ondemand
				if (
					Object.hasOwn(notification.body, "notificated_resources") &&
					notification.event === "EVENT_ASSIGNED"
				) {
					const event = await this.getEventById(+notification.key);
					if (event) this.addEventToList(event);
				}
			});

			// Escuchar los cambios en el nodo web
			starCountRef.on("child_changed", (data) => {
				const notification = new Notification({
					...data.val(),
					key: data.key,
				});
				this.handleUpdateEvent(notification);
			});
		},
		/**
		 * TODO: Convertir el nombre del evento al id correspondiente
		 * @param {String} eventStatusName recibido en el cuerpo de la notificacion
		 */
		notificationEventStatus(eventStatusName) {
			const status = {
				EVENT_NOT_ASSIGNED: 1,
				EVENT_ASSIGNED: 2,
				EVENT_RESCHEDULED: 3,
				EVENT_DELAYED: 4,
				EVENT_ON_THE_WAY: 5,
				EVENT_IN_PROGRESS: 6,
				EVENT_FINALIZED: 7,
			};
			return status[eventStatusName];
		},
		goToResourceCalendar(resourceId) {
			this.$router.push({
				name: "resource-calendar",
				params: {id: resourceId},
			});
		},
	},

	created() {
		if (!moduleSchedule.isRegistered) {
			this.$store.registerModule("moduleSchedule", moduleSchedule);
			moduleSchedule.isRegistered = true;
		}

		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}

		this.getEvents();
	},
};
</script>

<style lang="scss" scoped>
.bg-agendado {
	background-color: #3aaaff !important;
}

.bg-reprogramado {
	background-color: #ffe15a !important;
}

.bg-cancelado {
	background-color: #ff0000 !important;
}

.bg-finalizado {
	background-color: #28c76f !important;
}

.bg-en_proceso {
	background-color: #113a60 !important;
}

.bg-delayed {
	background-color: #ff7070 !important;
}

.bg-on-the-way {
	background-color: #ffbe81 !important;
}

.bg-selected {
	background-color: #a0a0a0 !important;
}

.bg-ondemand {
	background-color: #886ce4 !important;
}
</style>
